<template>
    <div class="container-fluid vc-admin-group_form_tokens">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="pt-2">
                    <div class="d-block d-md-flex justify-content-between mb-3">
                        <div class="d-block d-md-flex flex-wrap align-items-center">
                            <template>
                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <span class="small">出国日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_start_gte"
                                                @change="onChangeSearchPeriodStartGte"
                                                type="date"
                                                class="form-control"
                                                style="min-width: 100px;">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_start_lte"
                                                @change="onChangeSearchPeriodStartLte"
                                                type="date"
                                                class="form-control"
                                                style="min-width: 100px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <span class="small">帰国日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_end_gte"
                                                @change="onChangeSearchPeriodEndGte"
                                                type="date"
                                                class="form-control"
                                                style="min-width: 100px;">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_end_lte"
                                                @change="onChangeSearchPeriodEndLte"
                                                type="date"
                                                class="form-control"
                                                style="min-width: 100px;">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            
                            <div class="mt-2 mb-2 ml-lg-3 mb-lg-0">
                                <div class="c-freeword input-group input-group-sm">
                                    <input
                                        v-model="search.freeword"
                                        @blur="onChangeSearchFreeword"
                                        type="text"
                                        class="form-control"
                                        placeholder="フリーワード">
                                    <div class="input-group-append">
                                        <div
                                            class="c-freeword__btn input-group-text"
                                            @click="onChangeSearchFreeword">
                                            検索
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3 mt-md-2 mb-2 mb-md-0 ml-0 ml-md-2 text-right">
                            <button
                                type="button"
                                class="btn btn-yokumiru-orange"
                                style="min-width: 100px;"
                                @click="showModalAddForm()">
                                フォーム追加
                            </button>
                        </div>
                    </div>

                    <div :class="{ 'u-loader u-loader--p5' : !group_form_tokens }">
                        <div v-if="group_form_tokens">
                            <b-table
                                :items="group_form_tokens"
                                :fields="fields"
                                :sort-by.sync="$store.state.adminOrganizations.sortBy"
                                :sort-desc.sync="$store.state.adminOrganizations.sortDesc"
                                @sort-changed="fetchGroupFormTokens"
                                :tbody-tr-class="rowClass"
                                striped
                                hover
                                responsive
                                class="table-bordered m-table">
                                <template v-slot:cell(name_kana)="data">
                                    {{ data.item.name }}
                                    <div class="small">{{ data.item.name_kana }}</div>
                                </template>

                                <template v-slot:cell(group_management_tags.name)="data">
                                    <div class="groupManagementTagsWrapper d-flex align-items-center">
                                        <div
                                            v-for="tag in data.item.group_management_tags"
                                            class="d-flex align-baseline">
                                            <div class="groupManagementTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                                        </div>
                                    </div>
                                </template>

                                <template v-slot:cell(form_url)="data">
                                    <div class="d-flex align-items-center">
                                        <div class="formUrlWrapper text-muted">{{ data.item.form_url }}</div>
                                        <div
                                            v-if="data.item.is_enabled"
                                            class="copyUrlBtn"
                                            :class="{ 'copied' : copiedItemId === data.item.token }"
                                            @click="copyUrl(data.item)">
                                            <div v-if="copiedItemId === data.item.token">
                                                <b-icon-clipboard-check></b-icon-clipboard-check>
                                                <span>コピーしました！</span>
                                            </div>
                                            <div v-else>
                                                <b-icon-clipboard></b-icon-clipboard>
                                                <span>URLをコピー</span>
                                            </div>
                                        </div>
                                        <div
                                            v-else
                                            class="disabledUrlBtn"
                                            :class="{ 'copied' : copiedItemId === data.item.token }">
                                            <div>
                                                <b-icon-clipboard></b-icon-clipboard>
                                                <span>URLをコピー</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-slot:cell(period_start)="data">
                                    <template v-if="data.item.period_start">
                                        <span class="u-palt">
                                        {{ helper.dateForHuman(data.item.period_start, timezoneAsia) }}
                                    </span>
                                    <span
                                        class="u-palt"
                                        :class="helper.dayForHumanCSS(data.item.period_start , timezoneAsia)">
                                        {{ helper.dayForHuman(data.item.period_start, timezoneAsia, { bracket: true }) }}
                                    </span>
                                    </template>
                                    <template v-else></template>                                    
                                </template>

                                <template v-slot:cell(period_end)="data">
                                    <template v-if="data.item.period_end">
                                        <span class="u-palt">
                                            {{ helper.dateForHuman(data.item.period_end, timezoneAsia) }}
                                        </span>
                                        <span
                                            class="u-palt"
                                            :class="helper.dayForHumanCSS(data.item.period_end , timezoneAsia)">
                                            {{ helper.dayForHuman(data.item.period_end, timezoneAsia, { bracket: true }) }}
                                        </span>
                                    </template>
                                </template>

                                <template v-slot:cell(child_group_id)="data">
                                    <div v-if="data.item.child_group === null">-</div>
                                    <div v-else>
                                         <span>{{ data.item.child_group.name }}</span>
                                    </div>
                                </template>

                                <template v-slot:cell(is_authorizer)="data">
                                    <div>
                                        {{ data.item.is_authorizer ? 'する' : 'しない' }}
                                    </div>
                                </template>

                                <template v-slot:cell(is_enabled)="data">
                                    <div
                                        v-if="data.item.is_enabled"
                                        class="text-success">
                                        有効
                                    </div>
                                    <div
                                        v-else
                                        class="text-muted">
                                        無効
                                    </div>
                                </template>

                                <template v-slot:cell(links)="data">
                                    <b-button
                                        class="btn btn-yokumiru-blue btn-sm m-2"
                                        @click="showModalEditForm(data.item)">
                                        編集
                                    </b-button>
                                </template>
                            </b-table>

                            <div class="d-flex flex-wrap justify-content-between align-items-center">
                                <b-pagination
                                    :total-rows="$store.state.adminOrganizations.total"
                                    :per-page="$store.state.adminOrganizations.per_page"
                                    v-model="$store.state.adminOrganizations.current_page"
                                    @change="fetchGroupFormTokens">
                                </b-pagination>

                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="mr-3 mb-3">
                                        <span class="small">{{ dispPaginationDetail }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <admin-add-form-modal :group-type="groupTypeOrganization" :group="group"/>
        <admin-edit-form-modal :group-type="groupTypeOrganization" :group="group"/>
    </div>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'
    import {mapMutations} from 'vuex'

    export default {
        props: {
            timezone: {
                type: String,
                default: 'Asia/Tokyo',
            },
            group: {
                type: Object,
                required: true,
            },
            childGroupName: {
                type: String,
                default: '法人',
            },
            canDoctorPass: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                helper: YokumiruHelper,
                groupTypeOrganization: constants.groupType.organization,
                group_form_tokens: null,
                copiedItemId: null,
                orders: constants.orders,
                search: {
                    period_start_gte: null,
                    period_start_lte: null,
                    period_end_gte: null,
                    period_end_lte: null,
                    freeword: '',
                },
                sortBy: 'id',
                sortDesc: false,
                paginationConf: {
                    currentPage: 1,
                    perPage: 10,
                    totalRows: 0,
                    from: 0,
                    to: 0,
                },
                fields: [
                    {
                        'key': 'id',
                        'label': '#',
                        sortable: true,
                    },
                    {
                        'key': 'form_url',
                        'label': 'フォームURL',
                        sortable: false,
                    },
                    {
                        'key': 'plan.name',
                        'label': 'サービスモデル',
                        sortable: true,
                    },
                    {
                        'key': 'period_start',
                        'label': '出国日',
                        sortable: true,
                    },
                    {
                        'key': 'period_end',
                        'label': '帰国日',
                        sortable: true,
                    },
                    {
                        'key': 'group_name',
                        'label': '発行メール表記団体名',
                        sortable: true,
                    },
                    {
                        'key': 'child_group_id',
                        'label': `所属${this.childGroupName}`,
                        sortable: true,
                    },
                    {
                        'key': 'is_authorizer',
                        'label': '法人担当者設定',
                        sortable: true,
                    },
                    {
                        'key': 'is_enabled',
                        'label': 'フォームの状態',
                        sortable: true,
                    },
                    {
                        'key': 'links',
                        'label': '',
                        'class': 'text-center',
                        sortable: false,
                    },
                ],
            }
        },

        computed: {
            timezoneAsia: function () {
                return 'Asia/Tokyo'
            },
            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if ( this.$store.state.adminOrganizations.total < 1 ) {
                    return ''
                }
                return `全${this.$store.state.adminOrganizations.total}件中 ${this.$store.state.adminOrganizations.from}～${this.$store.state.adminOrganizations.to}件表示`
            },

            morphState: function () {
                return this.$store.state.adminOrganizations
            },
        },

        created: function () {
            if (this.$route.query.deleted === '1') {
                this.isOrganizationDeleted = true
            }
            this.initQueryFromState()
            this.initSearchCondition()
            this.fetchGroupFormTokens()

            bus.$on('fetch-group-form-tokens', this.fetchGroupFormTokens)
        },

        mounted: function () {
            if (this.isOrganizationDeleted) {
                bus.$emit('alert-success', '団体を削除しました。')
            }
        },

        beforeDestroy: function () {
            bus.$off('fetch-groups')
        },

        methods: {
            ...mapMutations({
                setQuery: 'adminOrganizations/setQuery',
                setQueries: 'adminOrganizations/setQueries',
            }),

            /**
             * URLのコピー
             * @param {object} item
             */
            copyUrl: function (item) {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(item.form_url).then(() => {
                        this.copiedItemId = item.token
                        setTimeout(() => this.copiedItemId = null, 1500)
                    })
                }
            },

            /**
             * 検索条件の初期化
             */
            initQueryFromState: function () {
                if (localStorage.getItem('yokumiruWeb')) {
                    const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                    if (data.adminOrganizations) {
                        this.setQueries(data.adminOrganizations)
                    }
                }
            },

            /**
             * 検索条件の初期化
             */
            initSearchCondition: function () {
                this.search.period_start_gte = this.morphState.period_start_gte
                this.search.period_start_lte = this.morphState.period_start_lte
                this.search.period_end_gte = this.morphState.period_end_gte
                this.search.period_end_lte = this.morphState.period_end_lte
                this.search.freeword = this.morphState.freeword
            },

            onChangeSearchPeriodStartGte: async function () {
                await this.setQuery({ key: 'period_start_gte', value: this.search.period_start_gte })
                await this.fetchGroupFormTokens(1)
            },

            onChangeSearchPeriodStartLte: async function () {
                await this.setQuery({ key: 'period_start_lte', value: this.search.period_start_lte })
                await this.fetchGroupFormTokens(1)
            },

            onChangeSearchPeriodEndGte: async function () {
                await this.setQuery({ key: 'period_end_gte', value: this.search.period_end_gte })
                await this.fetchGroupFormTokens(1)
            },

            onChangeSearchPeriodEndLte: async function () {
                await this.setQuery({ key: 'period_end_lte', value: this.search.period_end_lte })
                await this.fetchGroupFormTokens(1)
            },

            onChangeSearchFreeword: async function () {
                await this.setQuery({ key: 'freeword', value: this.search.freeword })
                await this.fetchGroupFormTokens(1)
            },

            /**
             * QueryString生成
             *
             * @param {boolean} paginate
             * @return {string}
             */
            buildQuery: function (paginate = true) {
                let query = '?'

                const state = this.morphState

                if (paginate) {
                    query += `page=${state.current_page}`
                }
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`

                if (state.freeword && state.freeword.length > 0) {
                    query += `&freeword=${state.freeword}`
                }

                if (state.period_start_gte) {
                    query += `&period_start_gte=${state.period_start_gte}`
                }
                if (state.period_start_lte) {
                    query += `&period_start_lte=${state.period_start_lte}`
                }
                if (state.period_end_gte) {
                    query += `&period_end_gte=${state.period_end_gte}`
                }
                if (state.period_end_lte) {
                    query += `&period_end_lte=${state.period_end_lte}`
                }

                return query
            },

            /**
             * 利用アカウント発行フォームURL一覧取得
             *
             * @param {number|object} param
             */
            fetchGroupFormTokens: async function (param = null) {
                this.group_form_tokens = null

                if (Number.isInteger(param) && param > 0) {
                    await this.setQuery({key: 'current_page', value: param})
                }
                else if (param !== null && param.hasOwnProperty('sortBy')) {
                    await this.setQuery({key: 'sortBy', value: param.sortBy})
                    await this.setQuery({key: 'sortDesc', value: param.sortDesc})
                }

                const endpoint = constants.admin.groups.endpoint.base

                axios.get(`${endpoint}/${this.group.id}/group_form_tokens${this.buildQuery()}`)
                .then(({data}) => {
                    this.group_form_tokens = data.data
                    this.setQueries(data.meta)
                        // this.setQuery({key: 'current_page', value: data.meta.current_page})
                        // this.setQuery({key: 'per_page', value: data.meta.per_page})
                        // this.setQuery({key: 'total', value: data.meta.total})
                        // this.setQuery({key: 'from', value: data.meta.from})
                        // this.setQuery({key: 'to', value: data.meta.to})
                    })
                    .catch(({response}) => {
                    if (response.status === 422) {
                        this.clearQueries()
                    }
                })
            },

            /**
             * 追加モーダル表示
             */
            showModalAddForm: function () {
                bus.$emit('open-modal-admin-add-form')
            },

            /**
             * 編集モーダル表示
             */
             showModalEditForm: function (groupFormToken) {
                bus.$emit('open-modal-admin-edit-form', groupFormToken)
            },

            /**
             * テーブル行クラス
             */
            rowClass: function (item, type) {
                if (item && type === 'row') {
                    if (item.flg_paused) {
                        return 'is-invalid'
                    }
                }
                return null
            },
        },
    }
</script>

<style lang="scss" scoped>
.formUrlWrapper {
    overflow-x: scroll;
    white-space: pre;
    width: 160px;
    padding: 5px 0;
    box-sizing: border-box;
}

.copyUrlBtn {
    margin-left: 15px;
    padding: 3px 8px;
    font-size: 11px;
    background: #dcdcdc;
    border-radius: 15px;
    cursor: pointer;
    transition: background 0.2s ease-out;

    &:hover {
        background: #cbcbcb;
    }

    &.copied {
        background: #daead9;
        transition: none;

        > div {
            color: #54a450;
        }
    }
}

.disabledUrlBtn{
    margin-left: 15px;
    padding: 3px 8px;
    font-size: 11px;
    background: #dcdcdc;
    border-radius: 15px;
    opacity: 0.5;
    cursor: default;
    transition: background 0.2s ease-out;
}
</style>

<style lang="scss">
.vc-admin-group_form_tokens {
    .b-table {
        min-width: 1500px;

        th, td {
            font-size: 0.75rem;
        }
    }
}
</style>
